<div
  class="wrapper"
  ui-popover-target
  #notificationPopoverTarget="ui-popover-target">
  <ui-button
    nuiType="plain-primary"
    [disabled]="disabled()"
    [nuiSvgIcon]="'notifications'"
    (click)="bellClicked()" />
  @if (hasUnreadNotifications()) {
    <div class="unread-dot"></div>
  }
</div>
<ns-notification-popover
  #notificationPopover
  (notificationClicked)="notificationClicked.emit($event)" />
<ns-quick-popover
  #quickPopover
  (notificationClicked)="notificationClicked.emit($event)" />
